import { BaseEntityResource } from '@/modules/core/app/resources/BaseEntityResource';
import { RouteGroup } from '@/modules/core/app/constants/api.constants';
import { Widget } from '@/modules/ta/widget/models/Widget';
import { DataSourceTypeCollection } from '@/modules/core/datasource/DataSourceTypeCollection';
import { GenericModel } from '@/modules/core/app/models/GenericModel';
import { DashboardRouteSegment } from '@/modules/ta/dashboard/dashboard.constants';

export class WidgetResource extends BaseEntityResource {
  constructor() {
    super(RouteGroup.DASH_WIDGETS, Widget);
  }

  /**
   * Custom endpoint to save all changes from the widget builder
   * @param data
   * @param id
   * @param config
   * @returns {Promise<*>}
   */
  saveBuilder(data, id, config = {}) {
    if (id) {
      return super.putData(data, `${DashboardRouteSegment.SAVE}/${id}`, config);
    }
    return super.postData(data, DashboardRouteSegment.SAVE, config);
  }

  /**
   /**
   * Return the export URL for widget exports.
   * @param type
   * @param params
   * @returns {string}
   */
  buildExportUrl(type, params) {
    return `${type}/${params.widgetId}`;
  }

  resize(widget) {
    const { id, width, height } = widget;
    return super.postData({ width, height }, `${DashboardRouteSegment.RESIZE}/${id}`);
  }

  /**
   * @param {string} type
   * @param {Object} params
   * @returns {*}
   */
  getMetadataColumnValues(type, params = {}) {
    return super.getData(
      DataSourceTypeCollection,
      `${RouteGroup.METADATA}/${type}/${RouteGroup.VALUE_SET}`,
      params
    );
  }

  /**
   * Return the plot type comparison values
   * @returns {*}
   */
  getComparisonValues() {
    return super.getData(GenericModel, RouteGroup.COMPARISON_OPTIONS);
  }

  /**
   * Return the plot type sparkline values
   * @returns {*}
   */
  getSparklineValues() {
    return super.getData(GenericModel, RouteGroup.SPARKLINE_OPTIONS);
  }

  /**
   * Return the mapbox credentials
   * @returns {*}
   */
  getMapboxAccessToken() {
    return super.getData(GenericModel, RouteGroup.MAPBOX_ACCESS_TOKEN);
  }

  /**
   * Endpoint to delete the filters of the widget
   * @param id
   * @returns {*}
   */
  deleteWidgetFilterSet(id) {
    return super.postData(GenericModel, `${RouteGroup.REMOVE_FILTER_SET}/${id}`);
  }

  /**
   * @returns {*}
   */
  getMapBoxLayers() {
    return super.getData(GenericModel, RouteGroup.PLOTTYPES_MAPBOXLAYERS);
  }
}

export default new WidgetResource();
